module.exports = __webpack_public_path__ + "static/img/shje.0282083.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ym/shje.png
// module id = z+Sw
// module chunks = 1